module.exports = __webpack_public_path__ + "img/social-instagram.e837c114.png";